import { MouseEventHandler } from "react";
import iconChevronLeftDark from "@assets/icon-chevron-left-dark.svg";
import iconChevronLeftLight from "@assets/icon-chevron-left-light.svg";
import { cn } from "@util/helpers";

type SplidePrevArrowProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
};

export default function SplidePrevArrow({
  onClick,
  className,
}: SplidePrevArrowProps): React.ReactElement {
  return (
    <button
      onClick={onClick}
      className={cn(
        "splide__arrow splide__arrow--prev",
        "relative left-[unset] right-0 top-[unset] translate-x-0",
        "!h-9 !w-9 rounded-full !border !border-solid border-gray-175 bg-white text-gray-850 !opacity-100 hover:border-gray-850",
        "group cursor-pointer disabled:cursor-auto disabled:border-gray-175",
        className
      )}
    >
      <img
        src={iconChevronLeftDark}
        width={24}
        height={24}
        alt="Prev slide"
        aria-label="Previous slide"
        className="block flex-shrink-0 group-disabled:hidden"
      />

      <img
        src={iconChevronLeftLight}
        width={24}
        height={24}
        alt="Prev slide"
        aria-label="Previous slide"
        className="hidden flex-shrink-0 group-disabled:block"
      />
    </button>
  );
}
